module.exports = __webpack_public_path__ + "static/media/arrow-top-orange.a1096143.svg";